import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL, // api
  timeout: 60 * 1000 // seconds request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },
  error => {
    let errorCode = 0
    let statusCode = 500
    const fallbackMessage = 'Request failed please try again'
    let message = fallbackMessage
    let string = fallbackMessage
    if (error.response) {
      const errorError = error.response.data.error.error
      let errArr = errorError
      string = errArr

      if (typeof errorError !== 'string') {
        string = ''
        errArr = Object.values(errorError)
        for (let index = 0; index < errArr.length; index++) {
          string += '- ' + errArr[index]
        }
      }

      if (error.response) {
        statusCode = error.response.data.error.status_code
        message = error.response.data.error.message
        errorCode = error.response.data.error.error_code
      } else {
        string = message
      }
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      statusCode,
      message,
      string,
      errorCode
    })
  }
)

export default service
